import { render, staticRenderFns } from "./BaseCategoryForm.vue?vue&type=template&id=5102ba71&scoped=true"
import script from "./BaseCategoryForm.vue?vue&type=script&lang=js"
export * from "./BaseCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./BaseCategoryForm.vue?vue&type=style&index=0&id=5102ba71&prod&lang=sass&scoped=true"
import style1 from "./BaseCategoryForm.vue?vue&type=style&index=1&id=5102ba71&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102ba71",
  null
  
)

export default component.exports